import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const languages = [
  { code: 'en', label: 'English', path: '/en/' },
  { code: 'pt', label: 'Português', path: '/pt/' },
  { code: 'de', label: 'Deutsch', path: '/de/' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const switchLanguage = (langCode: string) => {
    const currentPath = location.pathname;
    let newPath = currentPath;

    // Replace language prefix
    if (currentPath.startsWith('/en/')) {
      newPath = currentPath.replace('/en/', `/${langCode}/`);
    } else if (currentPath.startsWith('/pt/')) {
      newPath = currentPath.replace('/pt/', `/${langCode}/`);
    } else if (currentPath.startsWith('/de/')) {
      newPath = currentPath.replace('/de/', `/${langCode}/`);
    } else if (currentPath === '/en' || currentPath === '/pt' || currentPath === '/de') {
      newPath = `/${langCode}/`;
    } else if (currentPath === '/') {
      newPath = `/${langCode}/`;
    } else {
      // Default fallback
      newPath = `/${langCode}/`;
    }

    i18n.changeLanguage(langCode);
    navigate(newPath);
  };

  return (
    <div className="relative group">
      <button
        type="button"
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-200 transition-colors whitespace-nowrap"
        aria-label="Switch language"
      >
        <i className="ri-global-line w-4 h-4 flex items-center justify-center" />
        <span className="hidden sm:inline">
          {languages.find((l) => l.code === i18n.language)?.label || 'English'}
        </span>
        <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-xs" />
      </button>
      <div className="absolute right-0 top-full mt-1 w-40 bg-white rounded-lg shadow-lg border border-background-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            onClick={() => switchLanguage(lang.code)}
            className={`w-full text-left px-4 py-2.5 text-sm first:rounded-t-lg last:rounded-b-lg hover:bg-background-100 transition-colors ${
              i18n.language === lang.code ? 'text-primary-600 font-medium bg-primary-50/50' : 'text-foreground-700'
            }`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}